import {
  SHOW_NAVIGATION_MENU,
  HIDE_NAVIGATION_MENU,
} from "../actions/menuActions";

const initialState = {
  visibleMenu: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_NAVIGATION_MENU:
      return { ...state, visibleMenu: true };
    case HIDE_NAVIGATION_MENU:
      return { ...state, visibleMenu: false };
    default:
      return state;
  }
};
